export const removeLocalStorageItem = (key: string): void => {
  if (typeof window === 'undefined') {
    return
  }
  window.localStorage.removeItem(key)
}
